/**
 * Farm WebGIS FastAPI (crop calendar, NDVI, etc.).
 * No Digisaka bearer token — this service is separate from digisaka.app APIs.
 */
/** Production Farm WebGIS API — e.g. crop calendar from main-dashboard `HomePage` / `AnalysisPanel` only. */
import { DIGISAKA_API_ORIGIN } from './digisakaApiOrigin';

export const FARM_WEBGIS_API_BASE_URL = DIGISAKA_API_ORIGIN;

export function getFarmWebgisApiBaseUrl(): string {
  return FARM_WEBGIS_API_BASE_URL.replace(/\/$/, '');
}

/** Rice straw burn: whole province vs single municipality (FastAPI burn-detection endpoints). */
export type StrawBurnFetchPayload =
  | {
      mode: 'municipality';
      municipality_name: string;
      start_date?: string;
      end_date?: string;
    }
  | {
      mode: 'province';
      province_name: string;
      start_date?: string;
      end_date?: string;
    };

